<script>
export default {
    data() {
        return {
            system: '',
            country: '',
            tcModal: false,
            ppModal: false,
            form: {
                personal_strategy_before: this.oldInput && this.oldInput.personal_strategy_before ?
                    this.oldInput.personal_strategy_before :
                    null,
                qualified_coach: this.oldInput && this.oldInput.qualified_coach ?
                    this.oldInput.qualified_coach :
                    null,
                training_work: this.oldInput && this.oldInput.training_work ?
                    this.oldInput.training_work :
                    null,
                is_employer_paying: this.oldInput && this.oldInput.is_employer_paying ?
                    this.oldInput.is_employer_paying :
                    null,
                name: this.oldInput && this.oldInput.name ?
                    this.oldInput.name :
                    null,
                email: this.oldInput && this.oldInput.email ?
                    this.oldInput.email :
                    null,
                country: this.oldInput && this.oldInput.country ?
                    this.oldInput.country :
                    '',
                state: this.oldInput && this.oldInput.state ?
                    this.oldInput.state :
                    '',
                gender: this.oldInput && this.oldInput.gender ?
                    this.oldInput.gender :
                    '',
                year_of_birth: this.oldInput && this.oldInput.year_of_birth ?
                    this.oldInput.year_of_birth :
                    '',
                where_did_you_find: this.oldInput && this.oldInput.where_did_you_find ?
                    this.oldInput.where_did_you_find :
                    '',
                company: this.oldInput && this.oldInput.company ?
                    this.oldInput.company :
                    null,
                coached_before: this.oldInput && this.oldInput.coached_before ?
                    this.oldInput.coached_before :
                    '',
                language: this.oldInput && this.oldInput.language ?
                    this.oldInput.language :
                    '',
                eighteen_or_above: this.oldInput && this.oldInput.eighteen_or_above ?
                    this.oldInput.eighteen_or_above :
                    null,
                accept_tc: this.oldInput && this.oldInput.accept_tc ?
                    this.oldInput.accept_tc :
                    null,
                accept_pp: this.oldInput && this.oldInput.accept_pp ?
                    this.oldInput.accept_pp :
                    null,
            },
        }
    },

    props: ['oldInput'],

    computed: {
    },

    watch: {
    },

    methods: {
    }
}
</script>
